<div class="container container-wrapper page-container">
  <section *ngIf="!hideHeader">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 text-center">
          <ng-content select="[header-container]"></ng-content>
        </div>
      </div>
    </div>
  </section>
  <div class="row justify-content-center">
    <section class="col-12 col-xl-11">
      <div class="row component-area">
        <section *ngIf="!hideMain" [ngClass]="mainContainerCssClass">
          <ng-content select="[main-container]"></ng-content>
        </section>
        <section class="col-lg-3 sidebar-basket">
          <div class="row">
            <section class="col-lg-2 d-none d-md-block">
              <div class="row separator-v">
                <div></div>
              </div>
            </section>
            <section *ngIf="!hideMenu" class="mt-5 mt-lg-0 col-lg-10">
              <ng-content select="[menu-container]"></ng-content>
            </section>
          </div>
        </section>
      </div>
      <div *ngIf="!hideNavigation" class="row" [ngClass]="{'navigation': !isVUMode}">
        <div class="col-12 p-0">
          <div class="container p-0">
            <ng-content select="[navigation-container]"></ng-content>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>
